import { deleteApi, get, post } from "../GenericServices";

const OrderProposal = {
  listOrders: (queryString) => {
    return get(`order-proposal/orders?${queryString}`);
  },
  listTasks: (id) => {
    return get(`order-proposal/project-tasks-order?orderId=${id}`);
  },
  getOrder: (id) => {
    return get(`order-proposal/order/${id}`);
  },
  saveOrder: (data) => {
    return post("order-proposal/confirm", data);
  },
  waitingApprovalRollback: (id) => {
    return post(`order-proposal/reset-status/${id}`, {});
  },
  addProjectTaskOrder: (orderId, projectTaskId) => {
    return post(`order-proposal/project-tasks-order?orderId=${orderId}&projectTaskId=${projectTaskId}`, {});
  },
  deleteProjectTaskOrder: (id) => {
    return deleteApi(`order-proposal/project-tasks-order/${id}`);
  },
};

export default OrderProposal;
